import { render, staticRenderFns } from "./edit-carousel-meb.vue?vue&type=template&id=8f13821a&"
import script from "./edit-carousel-meb.vue?vue&type=script&lang=js&"
export * from "./edit-carousel-meb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports